import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OptInProfileDetailModalComponent } from './opt-in-profile-detail-modal.component';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from "@xref/xref-lib";
import {
  TooltipModule as XrefTooltipModule
} from '@xref/xref-lib';


@NgModule({
  declarations: [OptInProfileDetailModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    XrefTooltipModule
  ]
})
export class OptInProfileDetailModalModule { }
